<template>
  <div
    v-loading="loding"
    class="wrap"
    :element-loading-text="language('forgetPassword.placeholder5')"
  >
    <div>
      <!-- <div class="welcome">{{ language("forgetPassword.title") }}</div> -->
      <div class="sys_title" v-if="appTheme.theme">
        {{ appTheme.theme.title }}
      </div>
      <el-card class="login-form" >
        <div class="form_wrap" id="form_wrap_forgetPassword">
          <div class="register_header">
            <div class="goBack_wrap">
              <i class="el-icon-arrow-left goBack" @click="goBack"></i>
            </div>
            <div class="register_title">
              {{ language("forgetPassword.textTips1") }}
            </div>
          </div>
          <el-form
            :model="loginForm"
            :rules="rules"
            status-icon
            ref="ruleForm"
            class="form"
          >
            <el-form-item prop="name">
              <el-input
                v-model="loginForm.name"
                :width="100"
                :placeholder="
                  loginForm.type == 'phone'
                    ? language('forgetPassword.placeholderLoginName')
                    : language('forgetPassword.placeholderLoginName2')
                "
                @keyup.enter.native="doForgetPassword"
              >
                <el-select
                  v-model="area"
                  slot="prepend"
                  style="width: 100px"
                  v-if="loginForm.type == 'phone'"
                >
                  <el-option label="+852" value="+852"></el-option>
                  <el-option label="+853" value="+853"></el-option>
                  <el-option label="+86" value="+86"></el-option>
                  <el-option label="+886" value="+886"></el-option>
                </el-select>
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                type="password"
                v-model="loginForm.password"
                :width="100"
                :placeholder="language('forgetPassword.placeholderPassword')"
                @keyup.enter.native="doForgetPassword"
              ></el-input>
            </el-form-item>
            <el-form-item prop="password2">
              <el-input
                type="password"
                v-model="loginForm.password2"
                :width="100"
                :placeholder="language('forgetPassword.placeholderPassword2')"
                @keyup.enter.native="doForgetPassword"
              ></el-input>
            </el-form-item>
            <el-form-item prop="code">
              <el-input
                type="text"
                v-model="loginForm.code"
                :width="100"
                :placeholder="language('forgetPassword.placeholderCode')"
                @keyup.enter.native="doForgetPassword"
              >
                <div slot="append">
                  <el-button
                    type="primary"
                    @click="getCode"
                    v-if="showGetCodebutton"
                    class="getCodeButton"
                    >{{ language("forgetPassword.getCodeText") }}</el-button
                  >
                  <el-button type="primary" v-if="!showGetCodebutton">{{
                    languageTC("forgetPassword.getCodeText2", timeText)
                  }}</el-button>
                </div>
              </el-input>
            </el-form-item>
            <el-form-item prop="captcha" :style="'margin-bottom:'+ (captchaWidth && showCaptcha?'18px':'0px')">
            <div class="captcha_wrap" v-if="captchaWidth && showCaptcha">
              <Captcha
                buttonId="login_button"
                @captchaVerifyCallback="captchaVerifyCallback"
                :captchaWidth="captchaWidth"
              ></Captcha>
            </div>
          </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                style="width: 100%"
                @click="doForgetPassword"
                >{{ language("forgetPassword.submit") }}</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
const checkPhone = require("../rules/checkPhone.js").mixin;
const checkEmail = require("../rules/checkEmail.js").mixin;
const checkPassword = require("../rules/checkPassword.js").mixin;
import Captcha from "../components/Captcha.vue";

export default {
  mixins: [checkPhone, checkEmail, checkPassword],
  components: { Captcha },

  data() {
    return {
      facebook: require("../file/icon/facebook.png"),
      google: require("../file/icon/google.png"),
      loding: false,
      area: "+852",
      loginForm: {
        name: "",
        password: "",
        password2: "",
        code: "",
        type: "phone",
      },
      rules: {
        name: [
          {
            required: true,
            message: this.language("forgetPassword.rulesName"),
            trigger: "click",
          },
          { validator: this.checkLoginName, trigger: "blur" },
        ],
        password: [
          {
            required: true,
            message: this.language("forgetPassword.rulesPassword"),
            trigger: "click",
          },
          { validator: this.checkPasswordOne, trigger: "blur" },
        ],
        password2: [
          {
            required: true,
            message: this.language("forgetPassword.rulesPassword"),
            trigger: "click",
          },
          { validator: this.checkPasswordTwo, trigger: "blur" },
        ],
        code: [
          {
            required: true,
            message: this.language("forgetPassword.rulesCode"),
            trigger: "click",
          },
        ],
        captcha: [{ validator: this.checkCaptcha, trigger: "blur" }],
      },
      showGetCodebutton: true,
      timeText: 60,
      verifyResult: {
        captchaResult: false,
        bizResult: "",
      },
      showCaptcha: false,
      captchaWidth: 437,
      timeR:null

    };
  },
  watch: {},
  computed: {
    appTheme: function () {
      return this.$store.state.appData.appTheme;
    },
  },
  methods: {
    checkLoginName(rule, value, callback) {
      let text = "";
      if (this.loginForm.type == "phone") {
        text = this.checkPhone(this.area, this.loginForm.name);
      } else {
        text = this.checkEmail(this.loginForm.name);
      }
      if (text != "") {
        callback(new Error(text));
      } else {
        callback();
      }
    },
    checkPasswordOne(rule, value, callback) {
      let text = this.checkPassword(this.loginForm.password);
      if (text != "") {
        callback(new Error(text));
      } else {
        callback();
      }
    },
    checkPasswordTwo(rule, value, callback) {
      let text = this.checkPasswordSame(
        this.loginForm.password,
        this.loginForm.password2
      );
      if (text != "") {
        callback(new Error(text));
      } else {
        callback();
      }
    },
    checkCaptcha(rule, value, callback) {
      if (this.verifyResult.captchaResult == false && this.showCaptcha) {
        callback(new Error(this.language("login.captchaText")));
      } else {
        callback();
      }
    },
    handleClick(o, n) {},
    goBack() {
      this.goToPage({ url: "login", query: {} });
      // this.$router.go(-1)
    },
    getCode() {
      this.$refs.ruleForm.validateField("name", (e) => {
        if (e == "") {
          this.$refs.ruleForm.validateField("captcha", (e2) => {
            if (e2 == "") {
              let data = {};
              if (this.loginForm.type == "phone") {
                data = {
                  type: 0,
                  phone: this.loginForm.name,
                  area: this.area,
                };
              } else {
                data = {
                  type: 0,
                  email: this.loginForm.name,
                };
              }
              if (this.verifyResult.captchaResult == true && this.showCaptcha) {
                data.captcha = this.verifyResult.captcha;
              }
              oauthSDK
                .getForgetCode(data)
                .then((res) => {
                  this.timeText = 60;
                  this.countTime();
                  this.showGetCodebutton = false;
                  // this.verifyResult = {
                  //   captchaResult: false,
                  //   bizResult: "",
                  // };
                })
                .catch((err) => {
                  // this.defalutToast(err.message);
                  if (err.code == 40003) {
                    this.showCaptcha = true;
                    this.verifyResult = {
                      captchaResult: false,
                      bizResult: "",
                    };
                  } else {
                    this.defalutToast(err.message);
                  }
                  this.loding = false;
                });
            }
          });
        }
      });
    },
    countTime() {
      window.clearInterval(this.timeR);
      this.timeR = setTimeout(() => {
        this.timeText = this.timeText - 1;
        if (this.timeText > 0) {
          this.countTime();
        } else if (this.timeText == 0) {
          this.showGetCodebutton = true;
         window.clearInterval(this.timeR);
        }
      }, 1000);
    },
    doForgetPassword() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.loding = true;
          let data = {
            type: this.loginForm.type,
            name: this.loginForm.name,
            password: this.loginForm.password,
            code: this.loginForm.code,
          };
          if (this.loginForm.type == "phone") {
            data.area = this.area;
          }
          oauthSDK
            .resetPwd(data)
            .then((res) => {
              this.loding = false;
              this.$message.success(this.language("forgetPassword.success"));
              this.goToPage({ url: "login", query: {} });
              // this.replacePage({
              //   url: this.$urlData.logoutURL,
              //   query: {},
              // });
            })
            .catch((err) => {
              this.defalutToast(err.message);
              this.loding = false;
            });
        } else {
          return false;
        }
      });
    },
    captchaVerifyCallback(e) {
      this.verifyResult = e;
      this.getCode();
    },
  },
  mounted() {
    if (this.$router.history.current.query) {
      if (this.$router.history.current.query.type == "phone") {
        this.loginForm.type = "phone";
      } else {
        this.loginForm.type = "email";
      }
    }
    setTimeout(() => {
      this.captchaWidth = document.getElementById(
        "form_wrap_forgetPassword"
      ).offsetWidth;
    }, 2000);
  },
  created() {},
};
</script>

<style lang="scss"  scoped>
.wrap {
  height: 100vh;
}
.form_wrap {
  width: 80%;
  margin: 0 auto;
}
.welcome {
  color: lightblue;
  width: 600px;
  text-align: center;
  height: 100px;
  font-size: 80px;
  color: lightgray;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -350px;
  margin-left: -300px;
}
.sys_title {
  width: 600px;
  text-align: center;
  height: 100px;
  font-size: 25px;
  color: gray;
  position: absolute;
  // top: 35%;
  top: 40%;
  left: 50%;
  margin-top: -250px;
  margin-left: -300px;
}
.login-form {
  width: 600px;
  // height: 390px;
  position: absolute;
  top: 35%;
  left: 50%;
  margin-top: -150px;
  margin-left: -300px;
}
.form {
  margin-top: 20px;
}
.register_header {
  display: flex;
  font-size: 20px;
  justify-content: center;
  position: relative;
}
.register_title {
  font-size: 20px;
}
.goBack {
  position: absolute;
  left: 0px;
}
.goBack_wrap {
  padding: 5px;
}
</style>